import { useState } from 'react';
import { inMemoryKVStore } from '../../../../../../infra/persistence';
import { STATUS_FILTER_KEY } from '../../../types';
export var useStatusFilter = function () {
    var _a = useState(inMemoryKVStore.getItem(STATUS_FILTER_KEY) || 'all'), statusFilter = _a[0], setLocalStatusFilter = _a[1];
    var setStatusFilter = function (newStatusFilter) {
        setLocalStatusFilter(newStatusFilter);
        inMemoryKVStore.setItem(STATUS_FILTER_KEY, newStatusFilter);
    };
    return {
        statusFilter: statusFilter,
        setStatusFilter: setStatusFilter,
    };
};
